import { ROLES } from 'variables';
import { lazy } from 'react';
import Loadable from 'components/@ui/loader/Loadable';
import MonitorIcon from '@mui/icons-material/Monitor';
import FestivalIcon from '@mui/icons-material/Festival';
import PeopleIcon from '@mui/icons-material/People';
import BookOpenIcon from '@mui/icons-material/MenuBook';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

// EVENTS
const Events = Loadable(lazy(() => import('pages/media/event-management/event-listing/EventsTable')));
const EventCreation = Loadable(lazy(() => import('pages/media/event-management/event-creation/EventCreationPage')));
const EventEditPage = Loadable(lazy(() => import('pages/media/event-management/event-creation/EventEditPage')));
const EventDetails = Loadable(lazy(() => import('pages/media/event-management/event-details/EventDetailsPage')));
const ExperienceLevelCreation = Loadable(
  lazy(() => import('pages/media/event-management/event-details/experience-levels/ExperienceLevelCreationPage'))
);

// TERMINALS
const TerminalsOverview = Loadable(lazy(() => import('pages/media/terminals-management/index')));
const TerminalListing = Loadable(lazy(() => import('pages/media/terminals-management/terminal-listing/TerminalListingPage')));
const TerminalCreation = Loadable(lazy(() => import('pages/media/terminals-management/terminal-creation/TerminalCreationPage')));
const TerminalEditPage = Loadable(lazy(() => import('pages/media/terminals-management/terminal-creation/TerminalEditPage')));

// OPERATORS
const Operators = Loadable(lazy(() => import('pages/media/operator-management/operator-listing/OperatorsTable')));
const OperatorCreation = Loadable(lazy(() => import('pages/media/operator-management/operator-creation/OperatorCreationPage')));
const OperatorEditPage = Loadable(lazy(() => import('pages/media/operator-management/operator-creation/OperatorEditPage')));

// CHAPTERS
const Chapters = Loadable(lazy(() => import('pages/media/chapter-management/chapter-listing/ChaptersTable')));
const ChapterCreation = Loadable(lazy(() => import('pages/media/chapter-management/chapter-creation/ChapterCreationPage')));
const ChapterEditPage = Loadable(lazy(() => import('pages/media/chapter-management/chapter-creation/ChapterEditPage')));
const ChapterDetails = Loadable(lazy(() => import('pages/media/chapter-management/chapter-details/ChapterDetailsPage')));
const DisplayCreation = Loadable(lazy(() => import('pages/media/chapter-management/chapter-details/display-creation/DisplayCreationPage')));
const DisplayEditPage = Loadable(lazy(() => import('pages/media/chapter-management/chapter-details/display-creation/DisplayEditPage')));

// RUNBOOKS
const RunbooksTable = Loadable(lazy(() => import('pages/media/runbook-management/runbook-listing/RunbooksTable')));
const RunbookCreationPage = Loadable(lazy(() => import('pages/media/runbook-management/runbook-creation/RunbookCreationPage')));
const RunbookEditPage = Loadable(lazy(() => import('pages/media/runbook-management/runbook-creation/RunbookEditPage')));
const RunbookDetailsPage = Loadable(lazy(() => import('pages/media/runbook-management/runbook-details/RunbookDetailsPage')));
const ScheduleCreationPage = Loadable(lazy(() => import('pages/media/runbook-management/runbook-details/ScheduleCreationPage')));
const ContractsPage = Loadable(lazy(() => import('pages/media/contract-management/ContractsPage')));
const ActiveContractsPage = Loadable(lazy(() => import('pages/media/contract-management/ActiveContractsPage')));

// CHILD ACCOUNTS
const ChildAccounts = Loadable(lazy(() => import('pages/media/child-accounts-management/listing/ChildAccountsTable')));
const ChildAccountCreation = Loadable(lazy(() => import('pages/media/child-accounts-management/creation/ChildAccountCreationPage')));

export const mediaRoutes = [
  {
    path: 'events',
    element: <Events />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-events'
  },
  {
    path: 'events/new',
    element: <EventCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-events'
  },
  {
    path: 'events/:id/edit',
    element: <EventEditPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-events'
  },
  {
    path: 'events/:id',
    element: <EventDetails />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-events'
  },
  {
    path: 'events/:id/new',
    element: <ExperienceLevelCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-events'
  },
  {
    path: 'terminals',
    element: <TerminalsOverview />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-terminals'
  },
  {
    path: 'terminals/:type',
    element: <TerminalListing />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-terminals'
  },
  {
    path: 'terminals/:type/new',
    element: <TerminalCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-terminals'
  },
  {
    path: 'terminals/:type/:id/edit',
    element: <TerminalEditPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-terminals'
  },
  {
    path: 'operators',
    element: <Operators />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-operators'
  },
  {
    path: 'operators/new',
    element: <OperatorCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-operators'
  },
  {
    path: 'operators/:id/edit',
    element: <OperatorEditPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-operators'
  },
  {
    path: 'chapters',
    element: <Chapters />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-chapters'
  },
  {
    path: 'chapters/new',
    element: <ChapterCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-chapters'
  },
  {
    path: 'chapters/:id',
    element: <ChapterDetails />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-chapters'
  },
  {
    path: 'chapters/:id/edit',
    element: <ChapterEditPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-chapters'
  },
  {
    path: 'chapters/:id/new',
    element: <DisplayCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-chapters'
  },
  {
    path: 'chapters/:id/displays/:displayId/edit',
    element: <DisplayEditPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-chapters'
  },
  {
    path: 'runbooks',
    element: <RunbooksTable />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-runbooks-read'
  },
  {
    path: 'runbooks/new',
    element: <RunbookCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-runbooks-write'
  },
  {
    path: 'runbooks/:id/edit',
    element: <RunbookEditPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-runbooks-write'
  },
  {
    path: 'runbooks/:id',
    element: <RunbookDetailsPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-runbooks-read'
  },
  {
    path: 'runbooks/:id/schedules/new',
    element: <ScheduleCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-runbooks-write'
  },
  {
    path: 'runbooks/:id/schedules/:scheduleId/edit',
    element: <ScheduleCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-runbooks-write'
  },
  {
    path: 'contracts',
    element: <ContractsPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-contracts'
  },
  {
    path: 'active-contracts',
    element: <ActiveContractsPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-active-contracts'
  },
  {
    path: 'child-accounts',
    element: <ChildAccounts />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-child-accounts'
  },
  {
    path: 'child-accounts/new',
    element: <ChildAccountCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-child-accounts'
  },
  {
    path: 'child-accounts/:accountId/edit',
    element: <ChildAccountCreation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'media-child-accounts'
  }
];

export const mediaMenuItems = [
  {
    id: 'events',
    title: 'Events',
    type: 'item',
    url: '/events',
    icon: FestivalIcon,
    breadcrumbs: true,
    feature_code: 'media-events'
  },
  {
    id: 'terminals',
    title: 'Terminals',
    type: 'item',
    url: '/terminals',
    icon: MonitorIcon,
    breadcrumbs: true,
    feature_code: 'media-terminals'
  },
  {
    id: 'operators',
    title: 'Operators',
    type: 'item',
    url: '/operators',
    icon: PeopleIcon,
    breadcrumbs: true,
    feature_code: 'media-operators'
  },
  {
    id: 'chapters',
    title: 'Chapters',
    type: 'item',
    url: '/chapters',
    icon: BookOpenIcon,
    breadcrumbs: true,
    feature_code: 'media-chapters'
  },
  {
    id: 'runbooks',
    title: 'Runbooks',
    type: 'item',
    url: '/runbooks',
    icon: LibraryBooksIcon,
    breadcrumbs: true,
    feature_code: 'media-runbooks'
  },
  {
    id: 'contracts',
    title: 'Purchase Bundle',
    type: 'item',
    url: '/contracts',
    icon: ReceiptLongIcon,
    breadcrumbs: true,
    feature_code: 'media-contracts'
  },
  {
    id: 'active-contracts',
    title: 'Active Contracts',
    type: 'item',
    url: '/active-contracts',
    icon: AssignmentIcon,
    breadcrumbs: true,
    feature_code: 'media-active-contracts'
  }
  // {
  //   id: 'child-accounts',
  //   title: 'Child Accounts',
  //   type: 'item',
  //   url: '/child-accounts',
  //   icon: SupervisorAccountIcon,
  //   breadcrumbs: true,
  //   feature_code: 'media-child-accounts'
  // }
];
